module.exports = {"id":"194879","name":"Sergi Enrich","rating":"79","photo":"./data/images/photos/2/194879.png","club":{"name":"SD Eibar","logo":"./data/images/clubs/SDEibar.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SergiEnrich0.json
// module id = 3907
// module chunks = 0